module.exports = __webpack_public_path__ + "img/login-ecshopx.385f7720.jpg";